/**
 * State модуля manager-request.
 *
 * `calculateDebounceTimers` — ключ: productId → timeoutId.
 * Дебаунс 300мс на пересчёт, чтобы не слать AJAX на каждое нажатие клавиши в числовых полях.
 */

export const state = {
    calculateDebounceTimers: {},
    confirmCallback: null,
};
